// extracted by mini-css-extract-plugin
export var body = "paragraph-module--body--23b9f";
export var caption = "paragraph-module--caption--deb5d";
export var display = "paragraph-module--display--5a6ae";
export var paragraph = "paragraph-module--paragraph--08aac";